import { useCentrixApi } from "core/hooks/useCentrixApi";

export function useInsurerPayActive(shopId: string) {
  const { data } = useCentrixApi({
    path: "/api/app/estimate-request/configuration/{shopId}",
    parameters: { path: { shopId } },
    shouldFetch: !!shopId,
  });
  return Boolean(data?.isInsurerPayActive);
}
